/**
 * PriceDisplay Component - Shows price in DH, USD, EUR
 */
import React from 'react';

const PriceDisplay = ({ price, currencyRates, isDarkMode, size = 'sm' }) => {
  if (!price || price <= 0) return null;
  
  const usd = (price * currencyRates.USD).toFixed(2);
  const eur = (price * currencyRates.EUR).toFixed(2);
  
  const sizeClasses = size === 'lg' ? 'text-lg' : size === 'md' ? 'text-base' : 'text-sm';
  
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${sizeClasses}`}>
      <span className={`font-bold ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>
        {price} DH
      </span>
      <span className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
        ≈ ${usd} • €{eur}
      </span>
    </div>
  );
};

export default PriceDisplay;
